<mat-icon [class.text-info]="isNational()"> park </mat-icon>
